import { namedComponent } from '@packages/react/lib/named';
import React, { ComponentType, memo } from 'react';

interface ComponentOptions<P = Record<string, any>> {
    displayName?: string;
    defaultProps?: Partial<P>;
}

export const createMemo = <
    P extends Record<string, any>,
    O extends Record<string, any> = Record<string, any>,
    C extends ComponentType<P> = ComponentType<P>,
>(
    Component: React.ComponentType<C extends React.ComponentType<infer T> ? T : P>,
    options?: O & ComponentOptions<C extends React.ComponentType<infer T> ? T : P>,
): React.MemoExoticComponent<React.ComponentType<C extends React.ComponentType<infer T> ? T : P>> & O => {
    const { displayName, ...opts } = options!;
    const memo$ = memo(namedComponent(Component as any, displayName));

    memo$.displayName = `createMemo(${Component.displayName || displayName})`;

    Object.entries(opts).forEach(([key, value]) => (memo$[key] = value));

    return memo$ as any;
};
